import React, { MouseEventHandler, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import styled from "styled-components";
import iconListPin from "src/assets/images/iconListPin.svg";

interface INoticePinProps {
  data?: any;
  onClick?: MouseEventHandler<HTMLButtonElement> | any;
}

const NoticeListPinItem = (props: INoticePinProps) => {
  const [cmtRead, setCmtRead] = useState(true);
  const [datas, setDatas] = useState([]);

  useEffect(() => {
    setDatas(props.data.data);
  }, [props.data]);

  return (
    <>
      {/* 고정 리스트 */}
      {datas.length > 0 ? (
        <>
          {datas.map((v: any, idx: any) => {
            return (
              <li key={idx}>
                <NoticePinItemSet to={`/notice-detail/` + v.notice_idx}>
                  {/*<span className="cate">{v.cate_name}</span>*/}
                  <span className="title">{v.title}</span>
                  <span className="date">{moment(v.insert_date).format("YYYY.MM.DD")}</span>
                </NoticePinItemSet>
              </li>
            );
          })}
        </>
      ) : (
        ""
      )}
    </>
  );
};

const NoticePinItemSet = styled(Link)`
  display: inline-flex;
  align-items: center;
  width: 100%;
  padding: 16px 14px 14px 43px;
  border-bottom: 1px solid ${({ theme }) => theme.color.linePrimary};
  background-image: url(${iconListPin});
  background-repeat: no-repeat;
  background-position: 14px 13px;
  background-color: ${({ theme }) => theme.color.bgPrimary};
  .cate {
    padding-right: 20px;
    flex-shrink: 0;
  }
  .title {
    flex-grow: 1;
    ${({ theme }) => theme.textOverflow.singleLine()}
    font-size: 16px;
    font-weight: 700;
  }
  .date {
    padding-left: 20px;
    flex-shrink: 0;
    color: #747474;
  }
`;

export default NoticeListPinItem;
